
import { useState } from 'react';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import Product from './components/Product';
import WhyAluminum from './components/WhyAluminum';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Philosophy />
      <Product />
      <WhyAluminum />
      <Footer />
    </div>
  );
}
